export default "__VITE_ASSET__9d046c4b__"